<template>
    <BaseComponent name="newsletter_banner" v-if="showBanner">
        <hr class="my-0"/>
        <div class="newsletter-container bg-white-dark">
            <div class="container-xxl">
                <div class="row align-items-center py-4">
                    <div class="col col-12 col-md-auto mb-4 mb-lg-0 text-center text-md-start">
                        <h3 class="mb-3">
                            {{$t('newsletter_title') }}
                        </h3>
                        <p class="mb-0">
                            {{$t('newsletter_description') }}
                        </p>
                        <p>
                            {{$t('newsletter_cta') }}
                        </p>
                    </div>
                    <div class="col col-12 col-md-auto ms-auto">
                        <div class="d-flex justify-content-center justify-content-md-end">
                            <button @click="openSubscriptionModal()" class="btn btn-primary btn-lg w-100 w-lg-auto custom-lg-width">{{ $t('signup_button_text') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ModalContent id="NewsletterSubscription"/>
    </BaseComponent>
</template>

<script setup>
import {useModal} from "~/stores/ModalStore";
const NewsletterSubscription = defineAsyncComponent(() => import("~/components/Modals/Newsletter/NewsletterSubscription.vue"));
const ModalContent = defineAsyncComponent(() => import("~/components/Modals/ModalContent.vue"));
import {useCatalogStore} from "~/stores/CatalogStore.js";

const modals = useModal();
const route = useRoute();

const catalogStore = useCatalogStore();

const openSubscriptionModal = () => {
    modals.openModal('NewsletterSubscription', NewsletterSubscription);
};

const showBanner = computed(() => !route.matched[0]?.name.includes('newsletter') && !catalogStore.mobileSearch);

</script>
